import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes, RefObject } from 'react';
import { cn } from '@/lib/utils';
type LogoGlyphProperties = HTMLAttributes<HTMLSpanElement> & {
  /**
   * Width/height for the glyph. Accepts numbers (pixels) or any CSS length.
   */
  size?: number | string;
};
export const LogoGlyph = function LogoGlyphComponent(t0) {
  const $ = _c(18);
  let ariaHidden;
  let className;
  let reference;
  let rest;
  let style;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      style,
      "aria-hidden": ariaHidden,
      ref: reference,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = ariaHidden;
    $[2] = className;
    $[3] = reference;
    $[4] = rest;
    $[5] = style;
    $[6] = t1;
  } else {
    ariaHidden = $[1];
    className = $[2];
    reference = $[3];
    rest = $[4];
    style = $[5];
    t1 = $[6];
  }
  const size = t1 === undefined ? "0.875rem" : t1;
  const dimension = typeof size === "number" ? `${String(size)}px` : size;
  const t2 = ariaHidden ?? true;
  let t3;
  if ($[7] !== className) {
    t3 = cn("inline-block shrink-0", className);
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== dimension || $[10] !== style) {
    t4 = {
      width: dimension,
      height: dimension,
      backgroundColor: "currentColor",
      maskImage: "url(/assets/logo-white.png)",
      WebkitMaskImage: "url(/assets/logo-white.png)",
      maskRepeat: "no-repeat",
      WebkitMaskRepeat: "no-repeat",
      maskSize: "contain",
      WebkitMaskSize: "contain",
      maskPosition: "center",
      WebkitMaskPosition: "center",
      ...style
    };
    $[9] = dimension;
    $[10] = style;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== reference || $[13] !== rest || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <span {...rest} ref={reference} aria-hidden={t2} className={t3} style={t4} />;
    $[12] = reference;
    $[13] = rest;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
LogoGlyph.displayName = 'LogoGlyph';